import s from "./RecentActivityWidgetMobile.module.scss"

export const RecentActivityWidgetMobileSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__avatar} />
      <div className={s.skeleton__userSummary}>
        <div className={s.skeleton__title} />
        <div className={s.skeleton__summary} />
      </div>
      <div className={s.skeleton__arrow} />
    </div>
  )
}
